var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticStyle:{"background-color":"#fefefe"}},[_c('v-col',{staticClass:"fondo",attrs:{"lg":"7","md":"7","cols":"12"}}),_c('v-col',{attrs:{"lg":"5","md":"5","sm":"12","xs":"12","cols":"12"}},[_c('FormLogin')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }